import styled from '@emotion/styled';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Input } from 'src/shared/components/Input';

import { AbandonButton } from '../components/AbandonButton';
import { CoachIntroWrapper } from '../components/CoachIntroWrapper';
import { CommonStepButtons } from '../components/CommonStepButtons';
import { ProgressBar } from '../components/ProgressBar';
import { QuestionWrapper } from '../components/QuestionWrapper';
import { ScreenTitle } from '../components/ScreenTitle';
import { ScreenWrapper } from '../components/ScreenWrapper';
import { IntakeFormProps } from '../models/intakeForm';
import { getQuestionDataFor } from '../selectors/intakeFormSelectors';

const SixteenSpacer = styled('div')({
    minHeight: 16,
});

export const IntakeCoachImageFreeTextScreen: React.FC<IntakeFormProps> = ({
    coachAvatar,
    coachCredentials,
    coachFirstName,
    coachLastName,
    currentScreen,
    responses,
    screenCount,
    onAbandonClick,
    skipQuestion,
    saveResponse,
    goBack,
}) => {
    const responseStr = typeof responses === 'string' ? responses : '';
    const [response, setResponse] = useState(responseStr || '');
    const { t } = useTranslation();
    const { questionText, questionPlaceholder, questionId = '', screenIndex } = getQuestionDataFor(
        currentScreen,
    );

    const submitResponse = () => {
        saveResponse(questionId, response);
    };

    const handleAbandonClick = () => {
        onAbandonClick(response);
    };

    return (
        <ScreenWrapper>
            <ProgressBar percentage={Math.floor((screenIndex / screenCount) * 100)} />
            <AbandonButton onClick={handleAbandonClick} />

            <QuestionWrapper>
                <CoachIntroWrapper
                    coachAvatar={coachAvatar}
                    coachFirstName={coachFirstName}
                    coachLastName={coachLastName}
                    coachCredentials={coachCredentials}
                />
                <SixteenSpacer />
                <ScreenTitle>{t(questionText)}</ScreenTitle>
                <form onSubmit={submitResponse}>
                    <Input
                        type="textarea"
                        fieldId={`${questionId}_response`}
                        onChange={setResponse}
                        placeholder={t(questionPlaceholder as string)}
                        value={response}
                    />
                    <CommonStepButtons
                        disableForward={!response.length}
                        onSkipClick={skipQuestion}
                        onForwardClick={submitResponse}
                        onBackClick={goBack}
                    />
                </form>
            </QuestionWrapper>
        </ScreenWrapper>
    );
};
